export function getListingLabel(listing) {
  switch (listing.type) {
  case 'LotListing':
    return listing.number;
  case 'CondoListing':
    return listing.address2 || listing.number;
  case 'LeaseSpaceListing':
    return listing.address2;
  }
}

export function getListingTypeLabel(listing) {
  switch (listing.type) {
  case 'LotListing':
    return 'lot';
  case 'CondoListing':
    return 'condo';
  case 'LeaseSpaceListing':
    return 'lease';
  case 'Sale':
    return 'sale';
  }
}
